<template>
  <div>
    <div v-show="pc" class="infoWindow">
        <!-- <div class="icon">
            <span class="text1">2</span>
        </div> -->
        <div :class="item.type===2?'icon1':'icon'" @click="buriedPt('ses:list:' + item.name, 'o')">
            <span class="text1">{{item.index}}</span>
        </div>
        <p class="p1" @click="buriedPt('ses:list:' + item.name, 'o')">
            <span>{{item.name}}</span>
            <!-- <span>4.5km</span> -->
        </p>
        <p class="p2" @click="buriedPt('ses:list:' + item.name, 'o')">{{this.item.address}}</p>
        <p class="p3" @click="buriedPt('ses:list:' + item.name, 'o')">联系电话：{{item.tel}}</p>
        <p class="p4">
        <span @click="getLocation(infoData, item.tabType);buriedPt('ses:list:' + item.name, 'o')">获取路线</span>
      </p>
    </div>
    <div v-show="pc" class="mask1" @click="$emit('closeWin')"></div>
    <div v-show="!pc" class="mask" @click="$emit('closeWin')"></div>
    <div v-show="!pc" class="infoWindow1">
      <!-- <div class="icon">
          <span class="text1">2</span>
      </div> -->
      <!-- <div class="icon1">
          <span class="text1">2</span>
      </div> -->
      <p class="p1" @click="buriedPt('ses:list:' + item.name, 'o')">
          <span>{{item.name}}</span>
          <span>{{item.km}}</span>
      </p>
      <p class="p2" @click="buriedPt('ses:list:' + item.name, 'o')">{{this.item.address}}</p>
      <p class="p3" @click="buriedPt('ses:list:' + item.name, 'o')">联系电话：{{item.tel}}</p>
      <p class="p4">
        <span @click="getLocation(infoData, item.tabType);buriedPt('ses:list:' + item.name, 'o')">获取路线</span>
      </p>
      <div class="icon" @click="getLocation(infoData, item.tabType);buriedPt('ses:list:' + item.name, 'o')"></div>
  </div>
  </div>
    
</template>

<script>
export default {
  name: 'infoWindow',
  props: {
    infoData:{
      type:Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {}
    }
  },
  data () {
    return {
      pc:true,
      item:{
        index:'',
        name:'',
        address:'',
        tel:'',
        km:'',
        type:'',
        tabType:''
      }
    }
  },
  created () {
    // console.log(this.infoData.dataIndex,'//////////////////////////')
    // console.log(this.infoData.name,'//////////////////////////')
    // console.log(this.infoData.address,'//////////////////////////')
    // console.log(this.infoData.tel,'//////////////////////////')
    // console.log(this.infoData.km,'//////////////////////////')
    // console.log(this.infoData.tabType,'//////////////////////////')
    // console.log(this.infoData.type,'//////////////////////////')
    if(this.infoData.tabType === 'server'){
        this.item.index = this.infoData.dataIndex
        this.item.name = this.infoData.NAME1
        this.item.address = this.infoData.ServiceAddress
        this.item.tel = this.infoData.OfficeCall
        this.item.km = this.infoData.km
        this.item.tabType = this.infoData.tabType
        this.item.type = this.infoData.type
    }
    if(this.infoData.tabType === 'store1' || this.infoData.tabType === 'store' || this.infoData.tabType === 'search'){
        this.item.index = this.infoData.dataIndex
        this.item.name = this.infoData.name
        this.item.address = this.infoData.address
        this.item.tel = this.infoData.tel
        this.item.km = this.infoData.km
        this.item.tabType = this.infoData.tabType
        this.item.type = this.infoData.type
    }
    if(this._isMobile()){
      this.pc = false
    } else {
      this.pc = true
    }
  },
  mounted () {
    
  },
  methods: {
    _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },
    getLocation(param, type){
      this.$emit("getLocation",param, type)
    },
    buriedPt(parame1, parame2) {
      console.log(parame1, parame2,'/************/')
      LinkClick(parame1,parame2)
    }
   
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
 $base-font-size: 720;
/*@function rem($px) {
  @return ($px / $base-font-size) * 10rem;
} */
@function rem($px) {
  @return ($px / $base-font-size) * 100vw;
}
.mask{
      width: 100vw;
      height: 100vh;
      overflow: hidden;
      position: fixed;
      top: 0;
      left: 0;
      background-color: rgba(0,0,0,0.1);
      z-index: 1000;
    }
    .mask1{
      width: 100vw;
      height: 100vh;
      overflow: hidden;
      position: fixed;
      top: 0;
      left: 0;
      background-color: rgba(255,255,255,0.1);
      z-index: 1000;
    }
.infoWindow {
        // width: 350px;
        // min-width: 350px; 
        width: 400px;
        // max-height: 238px;
        background-color: #fff;
        border-radius: 20px;
        z-index: 2000;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        box-shadow: 0px 0px 12px rgba(0, 0, 0, .12);
        /* right: 0;
    bottom: 0; */
        margin: auto;
        padding: 37px 30px 33px 83px;
        z-index: 1001;

        .icon,.icon1 {
            width: 46px;
            height: 56px;
            background: url(../assets/img/icon1.png);
            background-size: 100% 100%;
            position: absolute;
            top: 29px;
            left: 33px;
            span{
                display: inline-block;
                margin-top: 10px;
                width: 46px;
                text-align: center;
                transform: scale(0.6);
            }
        }
        .icon1{
            background: url(../assets/img/icon2.png);
            background-size: 100% 100%;

        }

        .p1 {
            font-size: 16px;
            font-weight: 600;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            span {
                display: inline-block;
                width: 310px;
                word-break: break-all;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2; /* 这里是超出几行省略 */
                overflow: hidden;
            }

            span:nth-child(2) {
                font-size: 16px;
                color: #da4b44;
                display: inline-block;
                text-align: right;
                position: relative;
                top: 5px;
                width: 80px;
            }
        }

        .p2 {
            font-size: 14px;
            margin-top: 26px;
        }

        .p3 {
            font-size: 14px;
            margin-top: 10px;
        }

        .p4 {
            font-size: 16px;
            margin-top: 50px;
            color: #da4b44;
            cursor: pointer;
        }
    }
    
    .infoWindow1 {
        width:80%;
        max-height: rem(400);
        background-color: #fff;
        border-radius: rem(20);
        z-index: 1001;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        /* right: 0;
    bottom: 0; */
        margin: auto;
        padding: rem(60) rem(44);

        .p1 {
            font-size: rem(26);
            font-weight: 600;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            span {
                line-height: rem(26);
                display: inline-block;
                width: rem(320);
                word-break: break-all;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2; /* 这里是超出几行省略 */
                overflow: hidden;
            }

            span:nth-child(2) {
                font-size: rem(24);
                color: #1470b9;
                width: rem(150);
                text-align: right;
            }
        }

        .p2 {
            font-size: rem(22);
            margin-top: rem(26);
            line-height: rem(26);
        }

        .p3 {
            font-size: rem(22);
            margin-top: rem(10);
        }

        .p4 {
            font-size: rem(22);
            margin-top: rem(70);
            padding-left: rem(34);
            color: #da4b44;
        }
        .icon{
              width: rem(29);
              height: rem(40);
              position:absolute;
              left: rem(40);
              bottom: rem(50);
              background: url(../assets/img/icon4.png);
              background-size: cover;
        }
    }
</style>
